import _ from 'lodash';
import React from 'react';
import ChartBar from '../charts/bar';

const mapKeys = {
  'presidential-candidates': ['clinton', 'trump', 'other'],
  other: ['pro', 'anti', 'neutral']
}

const ChartBars = React.createClass({

  renderChartBars() {
    const dataset = window.location.pathname.split('/')[3];
    const data = this.props.data;
    const keys = mapKeys[dataset] || mapKeys.other;

    return _.map(keys, (key) => {
      return (
        <ChartBar
          type={key} key={key}
          data={data} />
      );
    });
  },

  render() {
    return (
      <div>
        { this.renderChartBars() }
      </div>
    );
  }
});

export default ChartBars;



/** WEBPACK FOOTER **
 ** ./src/components/charts/bars.js
 **/